import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { Segment, Grid } from 'semantic-ui-react';
import ShowMoreText from 'react-show-more-text';
import moment from 'moment';
import { dateRangePickerTitle } from '../../../utils';
import { isEmpty, map, filter } from '../../../utils/lodash';
import { HtmlService } from '../../../services';

import './activity.scss';

class ReportActivityComponent extends PureComponent {
  getFestivalTypes(festivalTypes) {
    if (isEmpty(festivalTypes)) return null;
    const usedFestivalTypes = map(festivalTypes, (i) => i.festivalTypeId) || [];
    if (isEmpty(usedFestivalTypes)) return null;
    const getFestivalTypes = filter(this.props.festivalTypes, (i) =>
      usedFestivalTypes.includes(i.id)
    );
    return map(getFestivalTypes, (i) => (
      <div className="projected-input-venues info-desc">{i.title}</div>
    ));
  }

  getPeriod() {
    const { t, periodStart, periodEnd } = this.props;
    let start = moment(periodStart).format('DD MMM YYYY');
    let end = moment(periodEnd).format('DD MMM YYYY');
    if (!periodStart) {
      start = '-';
    }
    if (!periodEnd) {
      end = '-';
    }
    let period = start + t('activity.report_activity.period_to') + end;
    if (!periodStart && !periodEnd) {
      period = '-';
    }
    return period;
  }

  render() {
    const { name, t, type } = this.props;

    return (
      <Segment className="report-activity-seg">
        <div className="report-activity-div">
          <Grid>
            {!this.props.hideActivityName && (
              <Grid.Row className="activity-name-row">
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <label className="info-title">
                    {t('common.activity_name')}
                  </label>
                  <p>{name || '-'}</p>
                </Grid.Column>
              </Grid.Row>
            )}
            <Grid.Row className="activity-name-row">
              <Grid.Column mobile={16} tablet={16} computer={16}>
                <label className="info-title">
                  {t('activity.report_activity.activity_description')}
                </label>
                <div className="info-desc info-desc-last">
                  {this.props.summary
                    ? HtmlService.convertToInnerHtml({
                        children: this.props.summary,
                        richText: true,
                        htmlConversionStyle: 'para',
                        returnAs: 'html',
                      })
                    : '-'}
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className="activity-name-row" columns={2}>
              <Grid.Column mobile={16} tablet={16} computer={6}>
                <label className="info-title">
                  {t('common.activity_type')}
                </label>
                <p>{type || '-'}</p>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={6}>
                <label className="info-title">
                  {dateRangePickerTitle(this.props)}
                </label>
                <p>{this.getPeriod()}</p>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className="activity-name-row" columns={2}>
              <Grid.Column mobile={16} tablet={16} computer={6}>
                <label className="info-title">
                  {t('activity.report_activity.organisation_goal')}
                </label>
                <p>{this.props.goal ? this.props.goal : '-'}</p>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={6}>
                <label className="info-title">
                  {t('formulary.goal_description')}
                </label>
                <ShowMoreText
                  lines={3}
                  more={t('common.read_more')}
                  less={t('common.read_less')}
                  anchorClass="show-more-less-clickable"
                  expanded={false}
                  truncatedEndingComponent={'... '}
                  className="pre-line"
                >
                  <p>
                    {this.props.goalDescription
                      ? this.props.goalDescription
                      : '-'}
                  </p>
                </ShowMoreText>
              </Grid.Column>
            </Grid.Row>
            {this.props.activityPlanTypeId === 3 && (
              <Grid.Row className="activity-name-row" columns={2}>
                <Grid.Column mobile={16} tablet={16} computer={6}>
                  <label className="info-title">
                    {t('activity.report_activity.festival_types')}
                  </label>
                  {!isEmpty(this.props.parentFestivals) ? (
                    this.getFestivalTypes(this.props.parentFestivals)
                  ) : (
                    <p>-</p>
                  )}
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>
        </div>
      </Segment>
    );
  }
}

export const ReportActivity = withTranslation()(ReportActivityComponent);
